import { TFunction } from "i18next"
import { useTranslation } from "react-i18next"

export default () => {
	const { t } = useTranslation("tournaments", { keyPrefix: "form.dataTableHeaders.tournamentMembers" })

	return columns(t)
}

const columns = (t: TFunction) => [
	{
		title: "ID",
		dataIndex: "id",
		key: "id",
		sorteable: true,
		width: "5rem"
	},
	{
		key: "email",
		title: t("email"),
		dataIndex: "email",
		width: "20rem"
	},
	{
		key: "name",
		title: t("name"),
		dataIndex: "name",
		width: "15rem"
	},
	{
		key: "surname",
		title: t("surname"),
		dataIndex: "surname",
		width: "15rem"
	},
	{
		key: "team",
		title: t("team"),
		dataIndex: "team",
		width: "8rem"
	}
]
